import React, { useMemo } from "react";
import { BsChevronDown, BsChevronUp } from "react-icons/bs";

type Props = {
  title: string;
  dropDownState: boolean;
};

const NavDropdownTitle = ({
  title,
  dropDownState,
}: Props): React.ReactElement => {
  return (
    <>
      <div className="nav-dropdown-title">
        {(() => {
          const rawLabel = (title || '').toString();
          const slugBase = rawLabel
            .toLowerCase()
            .trim()
            .replace(/[^a-z0-9\s-]/g, '')
            .replace(/\s+/g, '-')
            .replace(/-+/g, '-');
          const idAttr = `nav-item-${slugBase || 'title'}`;
          return (
            <div className="nav-item-text" id={idAttr} data-nav-slug={slugBase}>
              {rawLabel}
            </div>
          );
        })()}
        <div className="nav-spacer"></div>
        <div className="nav-icon">
          {dropDownState ? (
            <BsChevronUp size={15} />
          ) : (
            <BsChevronDown size={15} />
          )}
        </div>
      </div>
    </>
  );
};

export default NavDropdownTitle;
